import React, { Component } from "react";
import { find, filter } from "lodash";
import { URL_IMG } from "../../const";

export default class StoneByMonthItem extends Component {
  handleSelectSize() {
    let { props } = this;
    let { handleUpdateState, productList } = this.props;
    let item = find(productList, function(prod) {
      return prod.id === props.item.id;
    });

    if (item !== undefined) {
      handleUpdateState("isShowModalSelectSize", true);
      handleUpdateState("dataStoneItem", item);
    }
  }

  handleCheckSize() {
    let { props } = this;
    let { productList } = this.props;
    let materials = JSON.parse(localStorage.getItem("materials")) || [];
    let item = find(productList, function(prod) {
      return prod.id === props.item.id;
    });
    let listMaterialCurent = filter(materials, obj => obj.id === item.id);

    if (item !== undefined) {
      if (listMaterialCurent.length === item.sizes.length) {
        return true;
      }
    }

    return false;
  }

  render() {
    let { props } = this;
    let { productList } = props;
    let price = 0;
    let item = find(productList, function(prod) {
      return prod.id === props.item.id;
    });

    if (item !== undefined) {
      price = item.sizes.sort((a, b) => a.price - b.price)[0].price;
    } else {
        return '';
    }

    return (
      <li>
        <div className={`material_list_img`}>
          <img src={`${URL_IMG}${item.image_design}`} alt="" />
        </div>
        <div className="material_list_content">
          <h3>{item.name}</h3>
          <p>{item.detail}</p>
          <span>{price + "円"}</span>
        </div>
        {this.handleCheckSize() ? (
          <button className="material_list_btn disable">選択された</button>
        ) : (
          <button
            className="material_list_btn"
            onClick={() => this.handleSelectSize()}
          >
            選択
          </button>
        )}
      </li>
    );
  }
}
